export enum Severity {
  Error = 4,
  Warn = 3,
  Info = 2,
  Debug = 1,
  Trace = 0
}
